"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReferralType_Factory = /** @class */ (function () {
    function ReferralType_Factory() {
    }
    ReferralType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralTypeName: model.ReferralTypeName,
        };
        return result;
    };
    ReferralType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralTypeName: model.ReferralTypeName,
        };
        return result;
    };
    return ReferralType_Factory;
}());
exports.ReferralType_Factory = ReferralType_Factory;
